import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Products.css";
import Sidebar from "./Sidebar";
import Card from "./Card";
import { getAllProducts } from "../../services/auth/User";
import Loader2 from "../../components/Loader2";
import toast from "react-hot-toast";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Products() {
  const [products, setProducts] = useState([]);
  const [isPending, setIsPending] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const navigate = useNavigate();
  const query = useQuery();
  const searchQuery = query.get("keyword") || "";
  const categoryFilter = query.get("productCategory") || "";

  const fetchAllProducts = async (query = "", category = "", page = 1) => {
    setIsPending(true);
    try {
      const response = await getAllProducts(query, category, page);
      const { products, pageCount } = response; // Destructure pageCount from the response
      setProducts(products);
      setTotalPages(pageCount); // Set the total pages from response
    } catch (error) {
      console.error("Failed to fetch products:", error);
    } finally {
      setIsPending(false);
    }
  };

  useEffect(() => {
    const pageFromURL = parseInt(query.get("page") || "1", 10);
    setCurrentPage(pageFromURL);
    fetchAllProducts(searchQuery, categoryFilter, pageFromURL);
  }, [searchQuery, categoryFilter, query.get("page")]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handlePageChange = (newPage) => {
    if (newPage < 1) {
      toast.info("No previous page");
      return;
    } else if (newPage > totalPages) {
      toast.info("This is the last page");
      return;
    }
    setCurrentPage(newPage);
    navigate(`?keyword=${searchQuery}&productCategory=${categoryFilter}&page=${newPage}`);
    window.scrollTo(0, 0);
  };

  return (
    <>
      {isPending ? (
        <Loader2 />
      ) : (
        <div className="products">
          <div className="products-list">
            <Sidebar />
            {products.length === 0 ? (
              <div className="no-products">No products found for this search</div>
            ) : (
              <div className="products-flex">
                {products.map((product) => (
                  <Card key={product._id} product={product} />
                ))}
              </div>
            )}
            <div className="pagination">
              <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage <= 1}>
                Previous
              </button>
              <span>Page {currentPage} of {totalPages}</span>
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage >= totalPages}>
                Next
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Products;
